import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import TableLoader from "../../../loader/TableLoader";
import {
  NoItemsLeftInTable,
  roundToThreeDecimal,
} from "../../../../helpers/helpers";
import { Pagination } from "react-materialize";
import ToggleSwitch from "../../../../utils/TripleSwitchButton";

function ServiceCompletedLotTable({
  offers,
  loading,
  setAcceptedOffers,
  setRejectedOffers,
  lotApproved = false,
  startingPriceApproval,
}) {
  const totalNumberRow = 20;
  const isTablet = useMediaQuery({ query: "(max-width: 990px)" });
  const [currentPage, setCurrentPage] = useState(0);
  const navigate = useNavigate();
  const acceptedOffers = lotApproved?.acceptedOffers || [];
  const rejectedOffers = lotApproved?.rejectedOffers || [];


  const handleToggleChange = (offerId, newState) => {
    if (newState === "active") {
      // Add to acceptedOffers and remove from rejectedOffers
      setAcceptedOffers((prev) =>
        prev.includes(offerId) ? prev : [...prev, offerId]
      );
      setRejectedOffers((prev) => prev.filter((id) => id !== offerId));
    } else if (newState === "inactive") {
      // Add to rejectedOffers and remove from acceptedOffers
      setRejectedOffers((prev) =>
        prev.includes(offerId) ? prev : [...prev, offerId]
      );
      setAcceptedOffers((prev) => prev.filter((id) => id !== offerId));
    }
  };


  return (
    <div className="flex column full-width mt-1">
      {loading ? (
        <div className="valign-wrapper justify-center cover white">
          <TableLoader
            headerData={[
              "Lots Id",
              "Service title",
              "Category",
              "EMD Amount (Rs.)",
              "Starting price (Rs.)",
              "Max decrement (Rs.)",
              "Action",
            ]}
          />
        </div>
      ) : (
        <>
          <div
            className={`${!isTablet && "table-container-style"
              } mb-1 full-width`}
          >
            <table
              className={`responsive-table centered ${isTablet ? "auction_table table-style" : "custom-table-style"
                } `}
            >
              <thead>
                <tr>
                  {/* {!lotApproved && (
                    <th>
                      {" "}
                      <span
                        className="material-symbols-outlined pointer"
                        onClick={handleSelectAll}
                        style={{ cursor: "pointer" }}
                      >
                        {selectedOffers.length === offers?.length
                          ? "check_box"
                          : "check_box_outline_blank"}
                      </span>
                    </th>
                  )} */}
                  <th>Lots No.</th>
                  <th>Service title</th>
                  <th>Category</th>
                  <th>EMD Amount (Rs.)</th>
                  <th>Starting price (Rs.)</th>
                  <th>L1-Amount</th>
                  <th>View</th>
                  {!lotApproved && <th>Action</th>}
                </tr>
              </thead>
              <tbody>
                {offers
                  ?.slice(currentPage, currentPage + totalNumberRow)
                  ?.map((items) => {
                    const isAccepted = acceptedOffers.some(
                      (offer) => offer.offer === items._id
                    );
                    const isRejected = rejectedOffers.some(
                      (offer) => offer.offer === items._id
                    );
                    const rowStyle = {
                      backgroundColor: isAccepted
                        ? "rgb(235 255 229)"
                        : isRejected
                          ? "rgb(255 236 235)"
                          : "transparent",
                    };

                    return (
                      <tr key={items?._id} style={rowStyle}>
                        {/* {!lotApproved && (
                          <td style={{ width: "100px" }}>
                            <span
                              className="material-symbols-outlined pointer"
                              onClick={() => handleSelectOffer(items._id)}
                              style={{ cursor: "pointer" }}
                            >
                              {selectedOffers.includes(items._id)
                                ? "check_box"
                                : "check_box_outline_blank"}
                            </span>
                          </td>
                        )} */}
                        <td>{items?.offerNumber}</td>
                        <td style={{ width: !isTablet && "230px" }}>
                          <span
                            className="NoOfline"
                            style={{ WebkitLineClamp: 1 }}
                          >
                            {items?.serviceDetails?.title}
                          </span>
                        </td>
                        <td>
                          {" "}
                          {items?.serviceDetails?.category}
                        </td>
                        <td>{items?.EMDAmount}</td>
                        <td>
                          {startingPriceApproval ? items?.startingPrice : "N/A"}
                        </td>
                        <td>
                          {roundToThreeDecimal(items?.mimumestBid) ||
                            "N/A"}
                        </td>
                        <td>
                          <button
                            className="cercle-purple-text text-decoration-underLine pointer"
                            onClick={() =>
                              navigate(
                                `/service-reverse-auction/offerBids/${items.auction}/${items._id}`
                              )
                            }
                          >
                            <span className="material-symbols-outlined">
                              visibility
                            </span>
                          </button>
                        </td>
                        {!lotApproved && <td style={{ width: "130px", margin: "auto", padding: "0px 10px" }}><ToggleSwitch onChange={(newState) => handleToggleChange(items._id, newState)} /></td>}
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
          {offers?.length === 0 && <NoItemsLeftInTable />}
          {offers?.length > 20 && (
            <Pagination
              Data={offers}
              totalNumberRow={totalNumberRow}
              setCurrentPage={setCurrentPage}
            />
          )}
        </>
      )}
    </div>
  );
}

export default ServiceCompletedLotTable;
